import { Grid } from '@material-ui/core';
import { Progress } from '@backstage/core-components';
import { ScoreWithFixAndNoFix } from '@internal/ui-common';
import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import {
  getVulnerabilityScore,
  useGetVulnerabilities,
} from '@internal/backstage-plugin-zf-vulnerabilities';
import {
  VulnerabilitiesBarChart,
  VulnerabilitiesBarChartScale,
} from '@internal/backstage-plugin-zf-vulnerabilities';

export const VulnerabilityChart = ({
  teams,
  precalculatedScore,
  scale,
}: {
  teams?: Team[];
  precalculatedScore?: ScoreWithFixAndNoFix;
  scale?: VulnerabilitiesBarChartScale;
}) => {
  const { vulnerabilities, loading } = useGetVulnerabilities({
    teams,
  });

  const score = useMemo<ScoreWithFixAndNoFix>(() => {
    if (precalculatedScore) {
      return precalculatedScore;
    }

    return getVulnerabilityScore(vulnerabilities);
  }, [vulnerabilities, precalculatedScore]);

  if (loading) {
    return <Progress />;
  }

  return (
    <Grid container>
      <Grid container item xs={12} md={12}>
        <VulnerabilitiesBarChart score={score} scale={scale} />
      </Grid>
    </Grid>
  );
};
